/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";

import illustration1 from "../../assets/images/illustrations/pack4/404.svg";

export default () => {
  return (
    <div className="app-wrapper bg-white">
      <div className="app-main">
        <div className="app-content p-0">
          <div className="app-inner-content-layout--main">
            <div className="flex-grow-1 w-100 d-flex align-items-center">
              <div className="bg-composed-wrapper--content">
                <div className="hero-wrapper bg-composed-wrapper min-vh-100">
                  <div className="flex-grow-1 w-100 d-flex align-items-center">
                    <Col
                      lg="6"
                      md="9"
                      className="px-4 px-lg-0 mx-auto text-center text-black"
                    >
                      <img
                        src={illustration1}
                        className="w-50 mx-auto d-block my-5 img-fluid"
                        alt="..."
                      />

                      <h3 className="font-size-xxl line-height-sm font-weight-light d-block px-3 mb-3 text-black-50">
                        The page you were looking for doesn't exist.
                      </h3>
                      <p>
                        It's on us, we probably moved the content to a different
                        page.
                      </p>
                      <Row className="no-gutters">
                        <Col className="mt-4 mt-lg-3 px-2">
                          <Button
                            className="mx-auto w-30"
                            color="first"
                            tag={Link}
                            to={"/"}
                            size="lg"
                          >
                            <span className="btn-wrapper--label">Go home</span>
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
